const removeMask = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  return value.replace(/\D/g, '');
};

export default removeMask;
